import { SharedModule } from './../shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OsnSharedModule } from 'osn-shared';
import { FileUploadComponent } from './components/file-upload.component';
import { FileUploadEffects } from './file-upload.effects';
import * as fromFileUpload from './file-upload.reducer';
import { RemoveFileConfirmationDialogComponent } from './components/remove-file-confirmation-dialog/remove-file-confirmation-dialog.component';
import { DialogModule } from '../shared/components/dialog/dialog.module';

@NgModule({
  declarations: [FileUploadComponent, RemoveFileConfirmationDialogComponent],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromFileUpload.featureKey, fromFileUpload.reducer),
    EffectsModule.forFeature([FileUploadEffects]),
    OsnSharedModule,
    DialogModule,
  ],
  exports: [FileUploadComponent],
})
export class FileUploadModule {}
